// extracted by mini-css-extract-plugin
module.exports = {"passWrapper":"pass_passWrapper__1VMxi"};